import React, { Component } from 'react';
import FormForm from './FormForm';

export class CreateForm extends Component {
    static displayName = CreateForm.name;

    render() {
        return (
            <FormForm formId='0' formType='Create' />
        );
    }
}
